<template>
  <div class="skills-tech-cont" id="skills-tech-section">
    <div class="shadow-cont"></div>
    <div class="content">
      <div class="section-header">
        <h2>My Skills & Technologies</h2>
        <p class="hover-tech-icons">Hover Over the Tech Icons</p>
        <p class="tap-tech-icons">Tap the Tech Icons</p>
      </div>
      <div class="tech-icons-cont">
        <div class="card-wrapper flip-right">
          <div class="card">
            <div class="front">
              <img
                src="../assets/images/tech-icons/tech-html-logo.png"
                alt="html5"
              />
            </div>
            <div class="back">
              <img
                src="../assets/images/tech-icons/back-html-logo.png"
                alt="html5"
              />
            </div>
          </div>
        </div>
        <div class="card-wrapper flip-right">
          <div class="card">
            <div class="front">
              <img
                src="../assets/images/tech-icons/tech-css-logo.png"
                alt="html5"
              />
            </div>
            <div class="back">
              <img
                src="../assets/images/tech-icons/back-css-logo.png"
                alt="html5"
              />
            </div>
          </div>
        </div>
        <div class="card-wrapper flip-right">
          <div class="card">
            <div class="front">
              <img
                src="../assets/images/tech-icons/tech-js-logo2.png"
                alt="html5"
              />
            </div>
            <div class="back">
              <img
                src="../assets/images/tech-icons/back-js-logo2.png"
                alt="html5"
              />
            </div>
          </div>
        </div>
        <div class="card-wrapper flip-right">
          <div class="card">
            <div class="front">
              <img
                src="../assets/images/tech-icons/tech-jquery-logo.png"
                alt="html5"
              />
            </div>
            <div class="back">
              <img
                src="../assets/images/tech-icons/back-jquery-logo.png"
                alt="html5"
              />
            </div>
          </div>
        </div>
        <div class="card-wrapper flip-right">
          <div class="card">
            <div class="front">
              <img
                src="../assets/images/tech-icons/tech-php-logo.png"
                alt="html5"
              />
            </div>
            <div class="back">
              <img
                src="../assets/images/tech-icons/back-php-logo.png"
                alt="html5"
              />
            </div>
          </div>
        </div>
        <div class="card-wrapper flip-right">
          <div class="card">
            <div class="front">
              <img
                src="../assets/images/tech-icons/tech-wordpress-logo.png"
                alt="html5"
              />
            </div>
            <div class="back">
              <img
                src="../assets/images/tech-icons/back-wordpress-logo.png"
                alt="html5"
              />
            </div>
          </div>
        </div>
        <div class="card-wrapper flip-right">
          <div class="card">
            <div class="front">
              <img
                src="../assets/images/tech-icons/tech-photoshop-logo.png"
                alt="html5"
              />
            </div>
            <div class="back">
              <img
                src="../assets/images/tech-icons/back-photoshop-logo.png"
                alt="html5"
              />
            </div>
          </div>
        </div>
        <div class="card-wrapper flip-right">
          <div class="card">
            <div class="front">
              <img
                src="../assets/images/tech-icons/tech-premiere-logo.png"
                alt="html5"
              />
            </div>
            <div class="back">
              <img
                src="../assets/images/tech-icons/back-premiere-logo.png"
                alt="html5"
              />
            </div>
          </div>
        </div>
        <div class="card-wrapper flip-right">
          <div class="card">
            <div class="front">
              <img
                src="../assets/images/tech-icons/tech-sass-logo.png"
                alt="html5"
              />
            </div>
            <div class="back">
              <img
                src="../assets/images/tech-icons/back-sass-logo.png"
                alt="html5"
              />
            </div>
          </div>
        </div>
        <!-- <vue-flip active-hover>
          <template v-slot:front>
            <div class="flip-icon-front">
              <img
                src="../assets/images/tech-icons/tech-html-logo.png"
                alt="html5"
              />
            </div>
          </template>
          <template v-slot:back>
            <div class="flip-icon-back">
              <img
                src="../assets/images/tech-icons/back-html-logo.png"
                alt="html5"
              />
            </div>
          </template>
        </vue-flip> -->
      </div>
    </div>
  </div>
</template>

<script>
import VueFlip from "vue-flip";

export default {
  components: {
    "vue-flip": VueFlip,
  },
};
</script>

<style lang="scss">
@import "../scss/styles.scss";

.skills-tech-cont {
  position: relative;
  .shadow-cont {
    box-shadow: 0 11px 10px -4px rgb(0 0 0 / 60%);
    position: absolute;
    top: -22px;
    width: 100%;
    height: 22px;
  }
  .content {
    background: url("../assets/images/oregan-lake.jpg") no-repeat 50% scroll;
    background-size: cover;
    background-attachment: fixed;
    background-position: 50%;
    background-repeat: no-repeat;
    z-index: 5;
    padding: 0 1rem 12rem;
    @include md {
      padding: 0 1rem 10rem;
    }
    .section-header {
      padding: 6rem 0 0;
      h2 {
        margin: 0 0 1rem;
        font-size: 2.5rem;
      }
      .tap-tech-icons,
      .hover-tech-icons {
        color: $lt-gray;
        font-size: 1.5rem;
        text-align: center;
        text-shadow: #000 0 3px 3px;
      }
      .tap-tech-icons {
        @include sm {
          display: none !important;
        }
      }
      .hover-tech-icons {
        @include mobile-down {
          display: none !important;
        }
      }
    }
    p {
      margin-bottom: 2rem;
    }
    .tech-icons-cont {
      margin: auto;
      width: 100%;
      background-color: #ffffffb5;
      border-radius: 25px;
      max-width: 760px;
      padding: 1.5rem;
      box-shadow: #000 0 2px 4px;
      display: flex;
      justify-content: space-evenly;
      flex-wrap: wrap;
    }
  }
  // Flip Cards
  .card-wrapper {
    display: inline-block;
    perspective: 1000px;
    img {
      width: 205px;
      max-width: 100%;
      padding: 10px;
    }
  }
  .card-wrapper .card {
    position: relative;
    cursor: pointer;
    transition-duration: 0.6s;
    transition-timing-function: ease-in-out;
    transform-style: preserve-3d;
  }
  .card-wrapper .card .front,
  .card-wrapper .card .back {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    transform: rotateX(0deg);
  }
  .card-wrapper .card .front {
    z-index: 2;
  }
  .card-wrapper .card .back,
  .card-wrapper.flip-right .card .back {
    transform: rotateY(180deg);
  }
  .card-wrapper:hover .card,
  .card-wrapper.flip-right:hover .card {
    transform: rotateY(180deg);
  }

  .card-wrapper,
  .card {
    width: 205px;
    height: 205px;
  }
  .card .front,
  .card .back {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>